import { CssBaseline } from "@material-ui/core";
import Highcharts from "highcharts";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsExporting from "highcharts/modules/exporting";
import highMaps from "highcharts/modules/map";
import HighchartsOfflineExporting from "highcharts/modules/offline-exporting";
import VariwideModule from "highcharts/modules/variwide";
import PropTypes from "prop-types";
import TagManager from "react-gtm-module";
import { QueryClient, QueryClientProvider } from "react-query";
import { HashRouter as Router } from "react-router-dom";
import { ProvideAnalytics } from "../hooks/useAnalytics";
import { ProvideReadersGuide } from "../hooks/useReadersGuide";
import theme from "../theme";
import ThemeProvider from "./ThemeProvider";

TagManager.initialize({ gtmId: "GTM-PRXTSDN" });

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: theme.typography.fontFamily,
    },
  },
  lang: {
    numericSymbols: ["k", "M", "B", "T", "P", "E"],
  },
});

VariwideModule(Highcharts);
highMaps(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsOfflineExporting(Highcharts);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const Configuration = ({ children }) => (
  <Router>
    <ThemeProvider>
      <CssBaseline />
      <ProvideAnalytics>
        <QueryClientProvider client={queryClient}>
          <ProvideReadersGuide>
            <div>{children}</div>
          </ProvideReadersGuide>
        </QueryClientProvider>
      </ProvideAnalytics>
    </ThemeProvider>
  </Router>
);

Configuration.propType = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Configuration;
